module.exports = __webpack_public_path__ + "static/media/batch-transfer-sample.dcd75d83.csv";